import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { withFilters } from 'coreOld/components';
import { SelectionPanelNames } from 'coreOld/constants';
import { IFiltersProps } from 'coreOld/types';
import { getListPayload, isObject } from 'coreOld/utils';
import { useGetRequestList } from 'support/hooks';

import { columns } from './columns';
import RequestListView from './RequestListView';

const mapFilters = (filters) => {
  if (isObject(filters?.userId?.[0])) {
    return { ...filters, userId: filters.userId.map((userFilter) => userFilter.userId) };
  }

  return filters;
};

const RequestList = ({ filters }: IFiltersProps) => {
  const [closeSelection, setCloseSelection] = useState(false);
  const [isUpdateRequestOpen, setIsUpdateRequestOpen] = useState(false);

  const { t } = useTranslation();

  const {
    records,
    fetchNextPage,
    hasNextPage,
    isLoading,
    isFetching,
    isFetchingNextPage,
    isError,
  } = useGetRequestList(getListPayload(mapFilters(filters)));

  const selectOptionsConfig = () => [
    {
      section: [
        [
          {
            label: t('buttonLabelUpdate'),
            onClick: () => setIsUpdateRequestOpen(true),
          },
        ],
      ],
    },
  ];

  return (
    <RequestListView
      tableColumns={columns}
      filters={filters}
      data={records}
      isError={isError}
      isLoading={isLoading || (isFetching && !isFetchingNextPage)}
      hasNextPage={hasNextPage}
      fetchNextPage={fetchNextPage}
      isFetchingNextPage={isFetchingNextPage}
      selectionType={SelectionPanelNames.SUPPORT_REQUEST}
      selectOptionsConfig={selectOptionsConfig}
      closeSelection={closeSelection}
      setCloseSelection={setCloseSelection}
      isUpdateRequestOpen={isUpdateRequestOpen}
      setIsUpdateRequestOpen={setIsUpdateRequestOpen}
    />
  );
};

export default withFilters(RequestList);
